require('../../models/discipline/discipline');
require('../../models/document/document');

angular.module('far.documents.search', [
        'far.models.discipline',
        'far.models.document'
    ])
    .controller('DocumentsController', function ($log, $http, form, formsUtils, Document, Discipline) {
        var vm = {
            progress: true,
            submitted: false,
	        filterShow: true,
            form: form('DocumentsForm'),
            model: {},
            result: {
                offset: 0,
                limit: 100,
                data: []
            },
            total: {
                count: 0,
                pages: null
            },
            fistload: true,
            submit: function (next) {
                if (vm.submitted) {
                    return false;
                }

                if (!next) {
                    vm.result.offset = 0;
                    vm.result.data = [];
                    vm.total.count = 0;
                    vm.total.pages = null;
                }

                var data = {};
                for (var key in vm.model) {
                    if (typeof vm.model[key] == 'object' && vm.model[key] !== null) {
                        switch (key) {
                            case 'year':
                                data[key] = vm.model[key].year;
                                break;
                            default:
                                data[key] = vm.model[key].id;
                                break;
                        }
                    }
                }

                if (vm.model.hasOwnProperty('q')) {
                    data['q'] = vm.model['q'];
                }
                if(!window.location.href.includes('committee')){
                if(1 > Object.keys(data).length){
                    if('' !== window.location.hash){
                        try {
                            data = JSON.parse(decodeURIComponent(atob(window.location.hash.substring(1))));
                        } catch (exception){

                        }
                    }
                }
                }
                this.data = data;

                if(!window.location.href.includes('committee')) {
                    window.location.hash = btoa(encodeURIComponent(JSON.stringify(data)));
                }


                vm.submitted = true;

                $http.get(Routing.generate('api_get_document_search', data)).then(function (response) {
                    vm.total.count = response.headers('X-Total-Count');
                    vm.total.pages = Math.ceil(vm.total.count / vm.result.limit);

                    for (var id in response.data) {
                        response.data[id]['url'] = Routing.generate('document_download', {id: response.data[id].id});
                        response.data[id]['edit'] = Routing.generate('admin_document_edit', {id: response.data[id].id});

                        vm.result.data.push(response.data[id]);
                    }

                    vm.submitted = false;
                    vm.fistload = false;
                }, function errorCallback(response) {
                    $log.error(response);

                    vm.submitted = false;
                });
            },
            next: function () {
                vm.result.offset += vm.result.limit;

                vm.submit(true);
            },
            getTotalCount: function () {
                if (!vm.fistload) {
                    return formsUtils.numEnding(vm.total.count, ['Найден', 'Найдено', 'Найдено']) + ' ' + vm.total.count + ' ' + formsUtils.numEnding(vm.total.count, ['документ', 'документа', 'документов']);
                }
                return '';
            }
        };

        if(!window.location.href.includes('committee')) {
            if ('' !== window.location.hash) {
                try {
                    data = JSON.parse(decodeURIComponent(atob(window.location.hash.substring(1))));
                    vm.submit();
                } catch (exception) {

                }
            }
        }

        vm.form
            .addField('disciplines', 'selectObject', {
                validators: {
                    required: false
                },
                options: {
                    defaultOption: 'Дисциплина',
                    class: 'form__item form__item_select width-170',
                    ngChange: function () {

                    }
                },
                ngOptions: 'item as item.name for item in field.items track by item.id',
                label: null
            }, Discipline.list)
            .addField('types', 'selectObject', {
                validators: {
                    required: false
                },
                options: {
                    defaultOption: 'Тип документа',
                    class: 'form__item form__item_select width-220',
                    ngChange: function () {

                    }
                },
                ngOptions: 'item as item.name for item in field.items track by item.id',
                label: null
            }, Document.types)
            .addField('kinds', 'selectObject', {
                validators: {
                    required: false
                },
                options: {
                    defaultOption: 'Вид деятельности',
                    class: 'form__item form__item_select width-170',
                    ngChange: function () {

                    }
                },
                ngOptions: 'item as item.name for item in field.items track by item.id',
                label: null
            }, Document.kinds)
            .addField('new_committees', 'selectObject', {
                validators: {
                    required: false
                },
                options: {
                    defaultOption: 'Комитеты и комиссии (новое отображение)',
                    class: 'form__item form__item_select width-200',
                    ngChange: function () {

                    }
                },
                ngOptions: 'item as item.name for item in field.items track by item.id',
                label: null
            }, Document.new_committees)

            .addField('committees', 'selectObject', {
                validators: {
                    required: false
                },
                options: {
                    defaultOption: 'Комитеты и комиссии',
                    class: 'form__item form__item_select width-200',
                    ngChange: function () {

                    }
                },
                ngOptions: 'item as item.name for item in field.items track by item.id',
                label: null
            }, Document.committees)
            .addField('years', 'selectObject', {
                validators: {
                    required: false
                },
                options: {
                    defaultOption: 'Год',
                    class: 'form__item form__item_select width-80',
                    ngChange: function () {

                    }
                },
                ngOptions: 'item as item.year for item in field.items',
                label: null
            }, Document.years);

        return vm;
    });
